import { render } from "./organisation-activities.vue?vue&type=template&id=e60f1c0c&scoped=true"
import script from "./organisation-activities.vue?vue&type=script&lang=js"
export * from "./organisation-activities.vue?vue&type=script&lang=js"

import "./organisation-activities.vue?vue&type=style&index=0&id=e60f1c0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60f1c0c"]])

export default __exports__